angular.module('ihestiaCommonDirectives')
        .directive('focusOnFirstFormElement', ['$timeout', function($timeout) {
          return {
            restrict: 'A',
            scope: {
              selector: '='
            },
            link: function($scope, elem) {
              $timeout(function() {
                var firstInput = angular.element(
                        elem[0].querySelector($scope.selector))[0];

                if (firstInput) {
                  firstInput.focus();
                }
              }, 0);
            }
          };
        }]);